export default __webpack_public_path__ + "static/media/banner-first-image.066e2aa9.png";